import { Component, Vue, Watch } from 'vue-property-decorator'
import { DeviceType, SidebarType } from '@/store/modules/layout'
import { namespace } from 'vuex-class'

const { body } = document
const WIDTH = 1024
const RATIO = 3

const layoutModule = namespace('layout')

@Component
export default class ResizeHandlerMixin extends Vue {
  @layoutModule.State device!: DeviceType
  @layoutModule.State sidebar!: SidebarType
  @layoutModule.Action closeSidebar!: (withoutAnimation: boolean) => void
  @layoutModule.Action toggleDevice!: (device: DeviceType) => void

  @Watch('$route')
  onRouteChange() {
    if (this.device === DeviceType.Mobile && this.sidebar.opened) {
      this.closeSidebar(false)
    }
  }

  beforeMount() {
    window.addEventListener('resize', this.resizeHandler)
  }

  mounted() {
    const isMobile = this.isMobile()

    if (isMobile) {
      this.toggleDevice(DeviceType.Mobile)
      this.closeSidebar(true)
    }
  }

  isMobile() {
    const rect = body.getBoundingClientRect()

    return rect.width - RATIO < WIDTH
  }

  resizeHandler() {
    if (!document.hidden) {
      const isMobile = this.isMobile()

      this.toggleDevice(
        isMobile ? DeviceType.Mobile : DeviceType.Desktop
      )

      if (isMobile) {
        this.closeSidebar(true)
      }
    }
  }
}
